import * as React from "react";
import { Spinner } from "./../Spinner";

export interface LoadingIndicatorImplementationInterface {
  isLoading: boolean;
}

export const withLoadingIndicator = <T extends LoadingIndicatorImplementationInterface>(
  Component: React.FunctionComponent<T>
) => {
  const result = (props: T) => {
    return props.isLoading ? 
    <Spinner loading={props.isLoading}></Spinner> : 
    <Component {...props} />;
  };

  result.displayName = "withLoadingIndicator";

  return result;
}
